import { registerCollisionAnimation } from './CollisionAnimationRegistry';
import { seedRandom } from '../../../break/BreakUtils';

registerCollisionAnimation('SPIRAL_GALAXY', (ctx, e, config, progress, elapsed, globalHue, determineColor) => {
  const particles = config.collisionEffectParticleCount || 20;
  for (let i = 0; i < particles; i++) {
    const rnd = seedRandom(e.id, i);
    const arm = Math.floor(rnd * 3);
    const p = progress;
    const r = p * 100 + rnd * 20;
    const theta = p * 5 + (arm * Math.PI * 2 / 3);

    const x = e.pos.x + Math.cos(theta) * r;
    const y = e.pos.y + Math.sin(theta) * r;

    ctx.fillStyle = determineColor(i, particles);
    ctx.globalAlpha = 1 - progress;
    ctx.beginPath(); ctx.arc(x, y, 2, 0, Math.PI * 2); ctx.fill();
  }
});
